"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpServiceTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class HttpServiceTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(serviceTask, processModel) {
        var _a;
        super(serviceTask, processModel);
        this.method = (_a = this.customProperties) === null || _a === void 0 ? void 0 : _a.method;
        const params = this.getParamProperties(this.customProperties);
        if (params) {
            this.url = params.url;
            this.body = params.body;
            this.contentType = params.contentType;
            this.authorization = params.authorization;
        }
    }
    getParamProperties(customProperties) {
        const paramUrl = customProperties['studio.paramUrl'];
        const paramBody = customProperties['studio.paramBody'];
        const paramContentType = customProperties['studio.paramContentType'];
        const paramAuthorization = customProperties['studio.paramAuthorization'];
        if (paramUrl == null && paramBody == null && paramContentType == null && paramAuthorization == null) {
            return this.unreliableGetPropertiesFromParams(customProperties.params);
        }
        return {
            url: paramUrl,
            body: paramBody,
            contentType: paramContentType,
            authorization: paramAuthorization,
        };
    }
    unreliableGetPropertiesFromParams(paramsObject) {
        if (paramsObject == null) {
            return null;
        }
        let url;
        let body;
        let contentType;
        let authorization;
        let stringParams = (paramsObject === null || paramsObject === void 0 ? void 0 : paramsObject.trim()) || '';
        const hasHeaders = stringParams.includes('{"headers');
        let headers = '';
        if (hasHeaders) {
            const indexOfHeaders = stringParams.indexOf('{"headers"');
            headers = stringParams.substring(indexOfHeaders).replace(/]$/g, '');
            try {
                const parsedHeaders = JSON.parse(headers);
                contentType = parsedHeaders.headers['Content-Type'];
                authorization = parsedHeaders.headers.Authorization;
            }
            catch {
                // do nothing
            }
            stringParams = stringParams.substring(0, indexOfHeaders);
        }
        const hasBody = stringParams.includes(',');
        let newBody = '';
        if (hasBody) {
            const indexOfComma = stringParams.indexOf(',');
            newBody = stringParams
                .substring(indexOfComma)
                .trim()
                .replace(/,$/g, '');
            newBody = newBody.replace(/^,/, '').trim();
            const isPossibleObject = newBody.startsWith('{') && newBody.endsWith('}');
            if (!isPossibleObject) {
                newBody = newBody.replace(/]$/g, '').replace(/^"|"$/g, '');
            }
            body = newBody;
            stringParams = stringParams.substring(0, indexOfComma);
        }
        const noCommaInStringParams = !stringParams.includes(',');
        if (noCommaInStringParams) {
            url = stringParams
                .replace('[', '')
                .replace(/]$/g, '')
                .replace(/"/g, '')
                .trim();
        }
        if (url == null && body == null && contentType == null && authorization == null) {
            return null;
        }
        return {
            url: url,
            body: body,
            contentType: contentType,
            authorization: authorization,
        };
    }
}
exports.HttpServiceTaskViewModel = HttpServiceTaskViewModel;
//# sourceMappingURL=HttpServiceTaskViewModel.js.map